module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOXehpOqc.1f3909f6.woff2";